import { Component, PropTypes } from 'react';
import MediaQuery from 'react-responsive';
import cx from 'classnames';
import { breakpointSmallTo, breakpointLargeFrom } from 'config';
import styles from './styles.css';

export default class Modal extends Component {
	static propTypes = {
		isShown: PropTypes.bool.isRequired,
		onCloseClick: PropTypes.func.isRequired,
		image: PropTypes.string
	}

	renderImage() {
		return (
			<div className={styles.container}>
				<MediaQuery maxWidth={breakpointSmallTo}>
					<img className={styles.image} src={require(`./images/small/${this.props.image}`)} />
				</MediaQuery>

				<MediaQuery minWidth={breakpointLargeFrom}>
					<img className={styles.image} src={require(`./images/large/${this.props.image}`)} />
				</MediaQuery>
			</div>
		);
	}

	render() {
		const className = cx(styles.modal, {
			[styles.isShown]: this.props.isShown
		});

		return (
			<div className={className}>
				<div className={styles.close} onClick={this.props.onCloseClick} />

				{this.props.isShown && this.renderImage()}
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./components/Modal/index.js
 **/